document.addEventListener('submit', function (event) {
  const form = event.target;
  if (!form.matches('[data-type="add-to-cart-form"]')) return;

  const addonCheckbox = form.closest('.product__block, .product')?.querySelector('[data-addon-variant-id]')
    || document.querySelector('[data-addon-variant-id]');

  if (!addonCheckbox || !addonCheckbox.checked) return; // no addon selected, let theme handle normally
  event.preventDefault();
  event.stopPropagation();

  const variantId = form.querySelector('[name="id"]')?.value;
  const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
  const addonVariantId = addonCheckbox.dataset.addonVariantId;
  const submitButton = form.querySelector('[type="submit"]');

  if (!variantId || !addonVariantId) return;

  const cartItems = document.querySelector('cart-items');
  if (!cartItems || typeof cartItems.addToCart !== 'function') return;

  cartItems.addToCart(
    [
      { id: Number(variantId), quantity },
      { id: Number(addonVariantId), quantity }
    ],
    submitButton
  );
  submitButton?.addEventListener('theme:product:add', function handler() {
    addonCheckbox.checked = false;
    submitButton.removeEventListener('theme:product:add', handler);
  });
}, true);